// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1gZ72","buttons":"RemoveExpirationActionButtons_buttons__2M-mJ"};